export const availableCountries = ["AUS", "NZL"];
